var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Modal',{attrs:{"width":"1000"},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('p',{staticClass:"text-center",attrs:{"slot":"header"},slot:"header"},[_vm._v("关联任务")]),_c('div',[_c('Table',{attrs:{"stripe":"","size":"small","data":_vm.list,"columns":_vm.tableColumns}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }